import React, { PureComponent } from 'react';
import 'date-fns';
import { enUS, he } from "date-fns/locale";
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import { injectIntl } from "react-intl";
import { withTheme } from "styled-components";

class StaticDatePicker extends PureComponent {
	state = {
		open: false
	}

	show() {
		this.setState({ open: true })
	}

	hide() {
		this.setState({ open: false });
	}

	setValue(date) {
		this.setState({ open: false }, () => {
			this.props.dateSelected(date);
		});
	}

	render() {
		const { colors } = this.props.theme;
		let isHebrew = this.props.intl.locale.includes('he');
		const direction = isHebrew ? 'rtl' : 'ltr';

		const theme = createTheme({
			direction,
			MuiDialogActions: {
				root: {
					display: 'none',
				},
			},
			palette: {
				primary: {
					main: colors.modalPrimaryColor
				},
				secondary: {
					main: colors.safeText,
				},

			}
		})

		return <ThemeProvider theme={ theme }>
			<MuiPickersUtilsProvider locale={ isHebrew ? he : enUS } utils={ DateFnsUtils }>
				<DatePicker
					variant="dialog"
					autoOk
					clearable={ false }
					onClose={ () => this.hide() }
					format="dd/MM/yyyy HH:mm"
					ampm={ false }
					open={ this.state.open }
					onChange={ (date) => this.setValue(date) }
					minDate={ this.props.minDate }
					maxDate={ this.props.maxDate }
					cancelLabel={ () => null }
					okLabel={ () => null }
					DialogProps={ {
						style: { direction },
					} }
					TextFieldComponent={ () => null }
				/>
			</MuiPickersUtilsProvider>
		</ThemeProvider>;
	}
}

export default injectIntl(withTheme(StaticDatePicker), { withRef: true });

